/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function InfoOutlineIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "info-outline", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 8, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 10.5V9", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 12V16", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(InfoOutlineIcon);
export default ForwardRef;
//# sourceMappingURL=infoOutlineIcon.js.map